const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJjIconHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M7.782 10.75c-.448 0-.746.317-.746.755 0 .447.298.745.746.745.439 0 .755-.298.755-.745a.73.73 0 0 0-.755-.755M11 5.959c0-1.578-1.482-2.21-2.879-2.21-1.701 0-3.109.923-3.121 2.78l1.568.146c0-.907.364-1.93 1.517-1.93.869 0 1.377.489 1.377 1.045 0 1.643-2.388 1.714-2.169 3.959h.988C8.221 8.085 11 8.144 11 5.959",
    style: {
      fill: "#eb1600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2m0-1c-1.87 0-3.628.728-4.95 2.05S1 6.13 1 8s.728 3.628 2.05 4.95S6.13 15 8 15s3.628-.728 4.95-2.05S15 9.87 15 8s-.728-3.628-2.05-4.95S9.87 1 8 1",
    style: {
      fill: "#eb1600"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJjIconHelp);
export default __webpack_public_path__ + "static/media/JJ_Icon_Help.0daa6d990980e4e011d96ef55244abbe.svg";
export { ForwardRef as ReactComponent };